<template>
  <div class="frame">
    <div style="height:18px;background:#3c77f7;width:100%;border-radius:100px 100px 0 0;"></div>
    <div style="height:20px;padding:35px 0 25px 0;line-height:20px;text-align:center">{{tt}}</div>
<div @click="guan()" class="queding">确定</div>

  </div>
</template>

<script>
export default {
props:['showcont','tt'],
methods:{
  guan(){
    var mask_bg = document.getElementById("mask_bg");
    if (mask_bg != null)
        mask_bg.parentNode.removeChild(mask_bg);
    this.$emit('txt',false)
    
  }
}
}
</script>

<style>
.frame{
  background: white;
  position: fixed;
  top: 40%;
  left: 40%;
  width: 350px;
  height: 145px;
  z-index: 9999999999;
  border-radius:22px;
  font-size: 14px;
}
.queding{
  height: 30px;
  width: 90px;
  border-radius: 100px;
  border:1px solid white;
  color: white;
  background: #3c77f7;
  line-height: 28px;
  text-align: center;
  margin-left: 240px;
  cursor: pointer;
}
</style>